import { Injectable } from '@angular/core';

/**
 * A minimal leaf service that holds the user's Sentry consent flag.
 *
 * Kept dependency-free by design so it can be safely injected by
 * FlyFreelyErrorHandler, FlyFreelyLoggingService, and PreferencesService
 * without introducing circular dependencies.
 *
 * PreferencesService is the sole writer; all Sentry-gated code is a reader.
 */
@Injectable({ providedIn: 'root' })
export class SentryConsentService {
    allowSentry = false;
}
